export default __webpack_public_path__ + "static/media/educator_to_edtech.c829963c.png";